export enum DOTS_CONTROL_ICON_DIRECTION {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
}

export enum DOTS_CONTROL_VIEW {
    CLEAR = 'clear',
    PSEUDO = 'pseudo',
}
